import { FmImageListActionsProps } from "domains/file-manager/components/FileManagerImage/List/Actions";
import CopyPromptButton from "domains/file-manager/components/FileManagerImage/List/CopyPromptButton";
import ReuseButton from "domains/file-manager/components/FileManagerImage/List/ReuseButton";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";

export type ListActionsCustomProps = {
  isWithoutCopyPrompt?: boolean;
};

export type ListActionsProps = FmImageListActionsProps<ListActionsCustomProps>;

export default function ListActions({
  job,
  firstAsset,
  isWithoutCopyPrompt = false,
}: ListActionsProps) {
  const { isReader } = useTeamContext();

  if (isReader) {
    return null;
  }

  return (
    <>
      <ReuseButton job={job} firstAsset={firstAsset} />
      {!isWithoutCopyPrompt && (
        <CopyPromptButton job={job} firstAsset={firstAsset} />
      )}
    </>
  );
}

export function ListActionsImage(props: FmImageListActionsProps) {
  return <ListActions {...props} />;
}

export function ListActionsTexture(props: FmImageListActionsProps) {
  return <ListActions {...props} />;
}

export function ListActionsSkybox(props: FmImageListActionsProps) {
  return <ListActions {...props} isWithoutCopyPrompt />;
}

export function ListActions3D(props: FmImageListActionsProps) {
  return <ListActions {...props} isWithoutCopyPrompt />;
}

export function ListActionsVideo(props: FmImageListActionsProps) {
  return <ListActions {...props} />;
}
